module.exports = __webpack_public_path__ + "static/media/functionalClothing-large.2d6e536c.jpg";